import React from "react";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#001733] bg-gradient-to-br from-[#001228] via-[#002244] to-[#001733] p-4 select-none">
      {/* Background Radial Glow */}
      <div className="absolute w-72 h-72 rounded-full bg-[#05f5d9]/10 blur-3xl pointer-events-none" />

      {/* Centered Dark Glass Card */}
      <div className="relative flex flex-col items-center justify-center p-8 sm:p-10 rounded-3xl bg-[#001e42]/80 border border-[#05f5d9]/25 shadow-2xl backdrop-blur-md max-w-xs sm:max-w-sm w-full mx-auto">
        {/* Prominent Cropped Brand Logo */}
        <div className="relative flex items-center justify-center mb-6">
          <div className="absolute -inset-2 rounded-2xl bg-gradient-to-r from-[#05f5d9]/20 via-transparent to-[#05f5d9]/20 blur-md animate-pulse" />
          <img
            src="/logo_loader.png"
            alt="The Master IQ"
            className="relative w-44 sm:w-52 h-auto object-contain drop-shadow-[0_0_14px_rgba(5,245,217,0.45)] select-none"
          />
        </div>

        {/* Minimal Animated Teal Progress Bar */}
        <div className="w-36 sm:w-44 h-1.5 rounded-full bg-white/10 overflow-hidden relative">
          <div
            className="h-full bg-gradient-to-r from-[#05f5d9] via-[#20f5e0] to-[#05f5d9] rounded-full shadow-[0_0_8px_#05f5d9]"
            style={{
              width: "50%",
              animation: "pageLoaderSlide 1.2s ease-in-out infinite alternate",
            }}
          />
        </div>

        <span className="mt-4 text-xs font-semibold tracking-widest text-[#05f5d9] uppercase">
          Loading...
        </span>
      </div>

      <style>{`
        @keyframes pageLoaderSlide {
          0% { transform: translateX(-40%); }
          100% { transform: translateX(140%); }
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
